import { centsToDollars, formatCurrency } from '~/shared/lib/currency'
import { Chip, IconButton, Text } from '~/shared/ui'
import { getAdjustmentTypeLabel } from '../../../lib'
import type { AdjustmentFormValues } from '../../../model'

export function CollapsedAdjustmentCard({
  adjustment,
  onExpand,
  onDelete,
}: {
  adjustment: AdjustmentFormValues
  onExpand: () => void
  onDelete: () => void
}) {
  return (
    <div className="border-divider rounded-lg border">
      <div
        className="border-divider hover:bg-action-hovered flex cursor-pointer items-center justify-between border-b px-4 py-2 transition-colors"
        onClick={onExpand}
      >
        <Text appearance="SUBTITLE2">
          {adjustment.code} &mdash; {getAdjustmentTypeLabel(adjustment.code)}
        </Text>
        <IconButton
          size="medium"
          container="small"
          materialIcon="delete"
          title="Delete adjustment"
          onClick={(e) => {
            e.stopPropagation()
            onDelete()
          }}
        />
      </div>
      <div className="flex flex-col gap-1 px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Text
              appearance="BODY2"
              className="text-text-secondary"
            >
              Amount:
            </Text>
            {adjustment.deductFromTotalPaid && <Chip size="xs">Deducted</Chip>}
          </div>
          <Text appearance="BODY2">{formatCurrency(centsToDollars(adjustment.amount) ?? 0)}</Text>
        </div>
        {adjustment.trackingNumber && (
          <div className="flex items-center justify-between">
            <Text
              appearance="BODY2"
              className="text-text-secondary"
            >
              Tracking Number:
            </Text>
            <Text appearance="BODY2">{adjustment.trackingNumber}</Text>
          </div>
        )}
      </div>
    </div>
  )
}
